
















import {Component, Prop} from 'vue-property-decorator'
import Vue from 'vue'
import Flex from '@/components/proxy/Flex.vue'
import Container from '@/components/proxy/Container.vue'
import Layout from '@/components/proxy/Layout.vue'
import Chip from '@/components/proxy/Chip.vue'
import Divider from '@/components/proxy/Divider.vue'
import Btn from '@/components/proxy/Btn.vue'
import CircleStatus from '@/components/CircleStatus.vue'
import VehicleTypeChip from '@/components/entities/vehicle/VehicleTypeChip.vue'
import StatusLabel from '@/components/StatusLabel.vue'
import {VehicleSlot} from '@/lib/kepler/interfaces'
import CustomIcon from '../../CustomIcon.vue'
import VehicleQuickInfo from './VehicleQuickInfo.vue'
import ServiceMesh from '../../../lib/serviceMesh'
import DateHelper from '@/lib/DateHelper'
import Accordion from '@/components/proxy/Accordion/Accordion.vue'
import AccordionContent from '@/components/proxy/Accordion/AccordionContent.vue'
import VehicleFares from '@/components/entities/vehicle/VehicleFares.vue'
import VehicleInstructions from '@/components/VehicleInstructions.vue'
import Utils from '@/utils'

@Component({
  components: {
    VehicleInstructions,
    VehicleFares,
    AccordionContent,
    Accordion,
    VehicleQuickInfo,
    CustomIcon,
    StatusLabel,
    VehicleLotAndDistance: Utils.loadComponent('entities/vehicle/VehicleLotAndDistance'),
    VehicleTypeChip, CircleStatus, Btn, Divider, Chip, Layout, Container, Flex,
  },
  name: 'VehicleSummary',
})
export default class VehicleSummary extends Vue {
  @Prop() public vehicleSlot!: VehicleSlot

  protected get vehicleTypeColor() {
    const key = `${this.vehicleSlot.reservation_type}${this.vehicleSlot.vehicle.category.type}`.toUpperCase()
    return {color: ServiceMesh.colors[key]}
  }

  protected get costString() {
    return `${this.$currency(this.vehicleSlot.base_rate.time_rate.driving_time_cost)}/${this.parseMinutes(this.vehicleSlot.base_rate.time_rate.time_cost_cycle)} - ${this.vehicleSlot.base_rate.distance_rate.distance_cost}/Km*`
  }

  protected parseMinutes(val: number) {
    return DateHelper.parseMinutes(this, val)
  }
}
